// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { FC, useContext } from 'react';
import DocumentTemplatePreview from '../../Molecules/Document/DocumentTemplatePreview';
import { QuestionnaireContext } from '../../Service/QuestionnaireContextV2';

const QuestionnairePreview: FC = () => {
  const { questionnaire } = useContext(QuestionnaireContext);
  const { id } = questionnaire ?? {};

  if (!questionnaire) return null;

  return (
    <DocumentTemplatePreview
      portalSupported
      entityType="questionnaires"
      entity={questionnaire}
      url={`${process.env.REACT_APP_QUESTIONNAIRE_SERVICE_URL}/questionnaires/${id}/pdf`}
    />
  );
};

export default QuestionnairePreview;
